const formatDate = (date, options = {
    day: "2-digit", year: "numeric", month: "long",
}) => new Date(date).toLocaleString("en-US", {
    day: options.day,
    month: options.month,
    year: options.year,
    weekday: options.weekday,
});

export const formatHour = (dateString) => {
    const date = new Date(dateString);
    const timeString = date.toLocaleTimeString("en-US", { hour: "numeric" });
    return timeString;
};

export default formatDate;
